<puro-modal
  class="get-labels-cancel-shipment-dialog__modal"
  [className]="'get-labels-cancel-shipment-dialog__modal'"
  [open]="open()"
  [title]="modalTitle()"
  size="medium"
  [showCloseButton]="false"
  [closeOnBackdrop]="closeOnBackdrop()"
  [actions]="actions()"
  (closeModal)="onDismiss()"
  data-testid="get-labels-cancel-shipment-dialog"
>
  <puro-typography component="p" variant="body1" class="get-labels-cancel-shipment-dialog__body">
    {{ bodyText() }}
  </puro-typography>
</puro-modal>
